import { z } from 'zod';

/**
 * Developer "view as" (owner, 2026-10-26; DECISIONS "Developer view-as for every module, never
 * on LIVE"). A testing aid, not impersonation: the caller keeps their own role and permissions,
 * and only the email that modules see changes.
 *
 * - The app sends the email in this header on module requests only. A header, not a query
 *   parameter, so the address stays out of URLs and access logs (it is redacted in logs too).
 * - tenant-api honours it for every middleware module route, once, in the middleware host: the
 *   caller needs `dev.view_as` and the server's `TP_DEV_VIEW_AS` switch must be on (refused
 *   under NODE_ENV=production, so never on LIVE). Every use is audited; module writes are
 *   refused while it is present (VIEW_AS_READ_ONLY); it is refused while impersonating.
 */
export const VIEW_AS_HEADER = 'x-tp-view-as';

/** One app-wide permission (role editor group "Developer tools"); tenant_admin only. */
export const DEV_VIEW_AS_PERMISSION = 'dev.view_as';

/** Audit action for every request that carried an accepted view-as header. */
export const DEV_VIEW_AS_AUDIT_ACTION = 'dev.view_as';

/** The header value: an email, trimmed and lower-cased, at most 254 characters. */
export const viewAsEmailSchema = z.string().trim().max(254).toLowerCase().pipe(z.email());

/**
 * `/me` field (additive): present only while the server's switch is on. The app shows
 * Profile › Developer tools only with this AND the `dev.view_as` permission.
 */
export const devViewAsInfoSchema = z.object({ available: z.literal(true) });
export type DevViewAsInfo = z.infer<typeof devViewAsInfoSchema>;
